module.exports = __webpack_public_path__ + "static/media/article1sqr.dee5244d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/articles/article1sqr.jpeg
// module id = 94
// module chunks = 0